import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './popup.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Popup from 'react-popup';
import { ThemeProvider } from '@mui/material/styles';
import theme from './mui-theme';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
      <Popup closeBtn={false} />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
